import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import CardInfo from './CardInfo'
import { CuadernoTab } from './CuadernoTab'
import { BackButton } from '../../../../../components/buttons/ButtonDefault'
import { requestDefaulAuth } from '../../../../../http/httpRequest'

export const CuadernoHistorial = ({ mainReloadTable, setMainReloadTable }) => {
    const [reload, setReload] = useState(false)
    const [data, setData] = useState(null)
    // Cuaderno anterior/siguiente del MISMO vendedor (ordenados por código), para poder moverse
    // de cuaderno en cuaderno sin volver a la lista. null cuando no hay uno más (ej. el primero
    // no tiene anterior).
    const [adyacentes, setAdyacentes] = useState({ anterior: null, siguiente: null })
    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()
    const dispatch = useDispatch()

    useEffect(() => {
        requestDefaulAuth('get', `/cuaderno/${params.cuaderno_id}/adyacentes`, null, setAdyacentes, dispatch)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.cuaderno_id])

    const irACuaderno = (nuevoId) => {
        navigate(location.pathname.replace(`/historial/${params.cuaderno_id}`, `/historial/${nuevoId}`))
    }

    return (
        <div className='relative'>
            {/* Botón de siempre: volver a la lista de cuadernos, sin tocar */}
            <BackButton />

            {/* Navegador nuevo: cuaderno anterior/siguiente del mismo vendedor. Con otro color y
                separado del botón de volver para que no se confundan entre sí. */}
            <div className='flex items-center gap-1 absolute -top-[16px] right-3 z-10 bg-indigo-500 dark:bg-indigo-700 text-white rounded-full shadow px-1 py-1'>
                <button
                    onClick={() => adyacentes.anterior && irACuaderno(adyacentes.anterior.id)}
                    disabled={!adyacentes.anterior}
                    title={adyacentes.anterior ? `Ir al cuaderno ${adyacentes.anterior.codigo}` : 'No hay un cuaderno anterior de este vendedor'}
                    className='flex items-center justify-center w-6 h-6 rounded-full hover:bg-indigo-600 dark:hover:bg-indigo-800 disabled:opacity-30 disabled:hover:bg-transparent disabled:cursor-not-allowed'
                >
                    <i className='fa-solid fa-chevron-left text-xs' />
                </button>
                <span className='text-xs font-bold px-2 min-w-[64px] text-center'>
                    {data?.codigo ?? '...'}
                </span>
                <button
                    onClick={() => adyacentes.siguiente && irACuaderno(adyacentes.siguiente.id)}
                    disabled={!adyacentes.siguiente}
                    title={adyacentes.siguiente ? `Ir al cuaderno ${adyacentes.siguiente.codigo}` : 'No hay un cuaderno siguiente de este vendedor'}
                    className='flex items-center justify-center w-6 h-6 rounded-full hover:bg-indigo-600 dark:hover:bg-indigo-800 disabled:opacity-30 disabled:hover:bg-transparent disabled:cursor-not-allowed'
                >
                    <i className='fa-solid fa-chevron-right text-xs' />
                </button>
            </div>

            <CardInfo
                reload={reload}
                data={data}
                setData={setData}
            />
            <CuadernoTab
                reload={reload}
                setReload={setReload}
                dataCard={data}
                mainReloadTable={mainReloadTable}
                setMainReloadTable={setMainReloadTable}
            />
        </div>
    )
}
